import toast from 'react-hot-toast'

import { showApiError, useMutation } from '@fv/client-core'
import type { ClientAddressLookupResult } from '@fv/client-types'

import { shipperFetch } from '@/utils/shipperFetch'

import { addressMapper } from './addressFuncs'
import { useAddressBookCacheModifier } from './cache-modifiers'
import type { AddressBookListConfig, FormAddress } from './types'
import { normalizeAddressResult } from './utils'

async function createAddress(address: FormAddress) {
  return shipperFetch<ClientAddressLookupResult>(`/addresses`, {
    body: addressMapper.formAddressToDTO(address),
    method: 'POST',
  })
}

export function useCreateAddress(config: AddressBookListConfig, notify = true) {
  const { addToCache } = useAddressBookCacheModifier(config)

  return useMutation(createAddress, {
    onSettled: (_address, error) => {
      if (error && notify) return showApiError('Unable to add address', error)
      addToCache(normalizeAddressResult(_address))
      notify && toast.success('Address added successfully.')
    },
  })
}
